import { useEffect, useMemo, useState } from "react";
import { Page } from "../../../helbest";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import Item from "./Item/Item";
import styles from "./Notifications.module.css";
import { useTranslation } from "react-i18next";

import { ReactComponent as EmptyNotificationIcon } from "../../../assets/svg/empty-notifications.svg";
import { useDispatch, useSelector } from "react-redux";
import Details from "./Details/Details";
import Tabs from "../../components/Tabs/Tabs";
import ItemOrder from "./Item/ItemOrder";
import {
  set_notification_popover,
  set_open_new_notification,
} from "../../../store/actions/login_actions";

const TAB_KEYS = {
  all: "ALL",
  unread: "UNREAD",
  read: "READ",
};

const Notifications = () => {
  const [activeTab, setActiveTab] = useState(TAB_KEYS.all);
  const { Notification, Login } = useSelector((state) => state);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const TABS = useMemo(
    () => [
      { id: 0, label: t("notifications.tabs.all"), key: TAB_KEYS.all },
      { id: 1, label: t("notifications.tabs.unread"), key: TAB_KEYS.unread },
      { id: 2, label: t("notifications.tabs.read"), key: TAB_KEYS.read },
    ],
    [t]
  );

  useEffect(() => {
    dispatch(set_notification_popover(false));
    dispatch(set_open_new_notification(false));
  }, [dispatch]);

  const unseenCount = useMemo(
    () =>
      Notification.filter((notif) => notif.seen === false && !notif.is_expired)
        .length,
    [Notification]
  );

  return (
    <>
      <Page
        customHeader={<HeaderBack url={"/"} title={t("notifications.title")} />}
      >
        {Notification.length === 0 || !Login.is_login ? (
          <div className={styles.EmptyNotification}>
            <EmptyNotificationIcon className={styles.Icon} />
            <h3 className={styles.Title}>{t("notifications.empty_title")}</h3>
            <p className={styles.Message}>{t("notifications.empty_message")}</p>
          </div>
        ) : (
          <>
            <div className={styles.tabsContainer}>
              <Tabs
                tabs={TABS}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                unseenCount={unseenCount}
              />
            </div>
            <div className="w-full flex flex-column justify-start items-center">
              {Notification.filter((item) => {
                if (activeTab === TAB_KEYS.all) {
                  return item;
                }
                if (
                  activeTab === TAB_KEYS.unread &&
                  !item.seen &&
                  !item.is_expired
                ) {
                  return item;
                }
                if (
                  activeTab === TAB_KEYS.read &&
                  (item.seen || item.is_expired)
                ) {
                  return item;
                }
                return false;
              }).map((item) => {
                if (item?.type === "ORDER") {
                  return <ItemOrder key={item.send_time} {...item} />;
                }
                return <Item key={item.send_time} {...item} />;
              })}
            </div>
          </>
        )}
      </Page>
      <Details />
    </>
  );
};

export default Notifications;
